
function canOverrideUpload(task, completionStep, userStepPermissions) {
  const stepStatus = completionStep.status;
  if ((userStepPermissions && userStepPermissions.has('photo_upload')) && 
    (
      (stepStatus == 'completed' && task.status == 'in_progress') ||
      (stepStatus == 'pending_review' || stepStatus == 'rejected') ||
      (stepStatus == 'pending_approval' && !completionStep.reviewed_at) ||
      (stepStatus == 'not_started')
    )
  ) {
    return true;
  }
  return false;
}

function canCompleteStep(task, completionStep) {
  if (task.status == 'completed'
      || (completionStep.completed_at && ((task.has_approver && completionStep.approved_at) || (task.has_reviewer && completionStep.reviewed_at)))) {
    return false;
  }
  return true;
}

// Helper function for getCompletionStepUserPermissions() (below)
function tasksPermissions({ view, task, taskStatus, userRole, assignments, isVendor, completionStep }) {
  const userStepPermissions = new Set();
  // alternate way to look at it that matches the matrix better

  /* 
    the base permissions to choose from

        userStepPermissions.add('view_task')
        userStepPermissions.add('view_completion_step')
        userStepPermissions.add('step_complete')
        userStepPermissions.add('photo_upload')
        userStepPermissions.add('photo_delete')
        userStepPermissions.add('add_comment')
        userStepPermissions.add("step_complete")
        userStepPermissions.add("mark_as_complete")
        userStepPermissions.add("override")
        userStepPermissions.add("accept/reject")
        userStepPermissions.add("mark_as_reviewed")
        userStepPermissions.add("mark_as_approved")
    */
  
  userStepPermissions.add(assignments.userAssignment == 'approver' ? 'is_approver' : assignments.userAssignment == 'reviewer' ? 'is_reviewer' : assignments.userAssignment);

  /// this way is easier to compare to the matrix though more verbose.
  switch (taskStatus) {
  case 'not_started':
    if (userRole == 'editor' || assignments.buildOwnerAssignment) {
      userStepPermissions.add('view_task');
      userStepPermissions.add('view_completion_step');
      userStepPermissions.add('photo_upload');
      userStepPermissions.add('photo_delete');
      userStepPermissions.add('step_update');
      userStepPermissions.add('step_complete');
      userStepPermissions.add('can_mark_all');
      userStepPermissions.add('add_comment');
    }
    else {
      switch (assignments.userAssignment) {
      case 'assignedTo':
        userStepPermissions.add('view_task');
        userStepPermissions.add('view_completion_step');
        userStepPermissions.add('photo_upload');
        userStepPermissions.add('photo_delete');
        userStepPermissions.add('step_update');
        userStepPermissions.add('step_complete');
        userStepPermissions.add('add_comment');
        userStepPermissions.add('mark_as_complete');
        break;
      case 'reviewer':
        userStepPermissions.add('view_task');
        userStepPermissions.add('view_completion_step');
        userStepPermissions.add('add_comment');
        break;
      case 'approver':
        userStepPermissions.add('view_task');
        userStepPermissions.add('view_completion_step');
        userStepPermissions.add('add_comment');
        break;
      case 'projectManager':
        userStepPermissions.add('view_task');
        userStepPermissions.add('view_completion_step');
        userStepPermissions.add('add_comment');
        break;
      case 'notify':
        userStepPermissions.add('view_task');
        userStepPermissions.add('view_completion_step');
        userStepPermissions.add('add_comment');
        break;
      default:
        break;
      }
    }
    break;
  case 'in_progress':
    if (userRole == 'editor' || assignments.buildOwnerAssignment) {
      userStepPermissions.add('view_task');
      userStepPermissions.add('view_completion_step');
      userStepPermissions.add('photo_upload');
      userStepPermissions.add('photo_delete');
      userStepPermissions.add('step_update');
      userStepPermissions.add('override');
      userStepPermissions.add('step_complete');
      userStepPermissions.add('add_comment');
      userStepPermissions.add('mark_as_complete');
      userStepPermissions.add('can_mark_all');
    }
    switch (assignments.userAssignment) {
    case 'assignedTo':
      userStepPermissions.add('view_task');
      userStepPermissions.add('view_completion_step');
      userStepPermissions.add('photo_upload');
      userStepPermissions.add('photo_delete');
      userStepPermissions.add('step_update');
      userStepPermissions.add('override');
      userStepPermissions.add('step_complete');
      userStepPermissions.add('add_comment');
      userStepPermissions.add('mark_as_complete');
      if (completionStep) {
        if (completionStep.status == 'completed') {
          if (task.has_reviewer && !completionStep.reviewed_at) {
            userStepPermissions.add('unmarkNA');
          }
          else if (!task.has_reviewer && task.has_approver && !completionStep.approved_at) {
            userStepPermissions.add('unmarkNA');
          }
        }
      }
      break;
    case 'reviewer':
      userStepPermissions.add('view_task');
      userStepPermissions.add('view_completion_step');
      userStepPermissions.add('add_comment');
      if (completionStep) {
        if (completionStep.completed_at && task.has_reviewer && !completionStep.reviewed_at && !completionStep.rejected_at) {
          userStepPermissions.add('accept/reject');
        }
      }
      else if (task) {
        if (task.has_reviewer) {
          userStepPermissions.add('accept/reject');
        }
      }
      break;
    case 'approver':
      userStepPermissions.add('view_task');
      userStepPermissions.add('view_completion_step');
      userStepPermissions.add('add_comment');
      if (completionStep) {
        if (completionStep.completed_at && task.has_approver && !completionStep.approved_at && !completionStep.rejected_at && ((task.has_reviewer && completionStep.reviewed_at) || !task.has_reviewer)) {
          userStepPermissions.add('accept/reject');
        }
      }
      else if (task) {
        if (task.has_approver || !task.has_reviewer) {
          userStepPermissions.add('accept/reject');
        }
      }
      break;
    case 'projectManager':
      userStepPermissions.add('view_task');
      userStepPermissions.add('view_completion_step');
      userStepPermissions.add('add_comment');
      break;
    case 'notify':
      userStepPermissions.add('view_task');
      userStepPermissions.add('view_completion_step');
      userStepPermissions.add('add_comment');
      break;
    default:
      break;
    }
    break;
  case 'rejected':
    if (userRole == 'editor' || assignments.buildOwnerAssignment) {
      userStepPermissions.add('view_task');
      userStepPermissions.add('view_completion_step');
      userStepPermissions.add('photo_upload');
      userStepPermissions.add('photo_delete');
      userStepPermissions.add('step_update');
      userStepPermissions.add('step_complete');
      userStepPermissions.add('override');
      userStepPermissions.add('add_comment');
      switch (assignments.userAssignment) {
      case 'reviewer':
        if (completionStep && task.has_reviewer && completionStep.completed_at && !completionStep.reviewed_at && !completionStep.rejected_at) {
          userStepPermissions.add('accept/reject');
          userStepPermissions.add('can_mark_all');
        }
        break;
      case 'approver':
        if (completionStep && completionStep.completed_at && task.has_approver && !completionStep.approved_at && !completionStep.rejected_at && ((task.has_reviewer && completionStep.reviewed_at) || !task.has_reviewer)) {
          userStepPermissions.add('can_mark_all');
          userStepPermissions.add('accept/reject');
        }
        break;
      default:
        break;
      }
    }
    else {
      switch (assignments.userAssignment) {
      case 'assignedTo':
        userStepPermissions.add('view_task');
        userStepPermissions.add('view_completion_step');
        userStepPermissions.add('photo_upload');
        userStepPermissions.add('photo_delete');
        userStepPermissions.add('step_update');
        userStepPermissions.add('step_complete');
        userStepPermissions.add('override');
        userStepPermissions.add('add_comment');
        break;
      case 'reviewer':
        userStepPermissions.add('view_task');
        userStepPermissions.add('view_completion_step');
        userStepPermissions.add('add_comment');
        if (completionStep && task.has_reviewer && completionStep.completed_at && !completionStep.reviewed_at && !completionStep.rejected_at) {
          userStepPermissions.add('accept/reject');
        }
        break;
      case 'approver':
        userStepPermissions.add('view_task');
        userStepPermissions.add('view_completion_step');
        userStepPermissions.add('add_comment');
        if (completionStep && completionStep.completed_at && task.has_approver && !completionStep.approved_at && !completionStep.rejected_at && ((task.has_reviewer && completionStep.reviewed_at) || !task.has_reviewer)) {
          userStepPermissions.add('accept/reject');
        }
        break;
      case 'projectManager':
        userStepPermissions.add('view_task');
        userStepPermissions.add('view_completion_step');
        userStepPermissions.add('add_comment');
        break;
      default:
        break;
      }
    }
    break;
  case 'pending_review':
    switch (assignments.userAssignment) {
    case 'assignedTo':
      userStepPermissions.add('view_task');
      userStepPermissions.add('view_completion_step');
      userStepPermissions.add('photo_upload');
      userStepPermissions.add('photo_delete');
      userStepPermissions.add('step_update');
      userStepPermissions.add('override');
      userStepPermissions.add('add_comment');
      if (completionStep) {
        if (completionStep.status == 'completed') {
          if (task.has_reviewer && !completionStep.reviewed_at) {
            userStepPermissions.add('unmarkNA');
          }
          else if (!task.has_reviewer && task.has_approver && !completionStep.approved_at) {
            userStepPermissions.add('unmarkNA');
          }
        }
      }
      break;
    case 'reviewer':
      userStepPermissions.add('view_task');
      userStepPermissions.add('view_completion_step');
      userStepPermissions.add('add_comment');
      if (completionStep && completionStep.completed_at && task.has_reviewer && !completionStep.reviewed_at && !completionStep.rejected_at) {
        userStepPermissions.add('accept/reject');
      }
      userStepPermissions.add('mark_as_reviewed');
      break;
    case 'approver':
      userStepPermissions.add('view_task');
      userStepPermissions.add('view_completion_step');
      userStepPermissions.add('add_comment');
      if (completionStep && completionStep.completed_at && task.has_approver && !completionStep.approved_at && !completionStep.rejected_at && ((task.has_reviewer && completionStep.reviewed_at) || !task.has_reviewer)) {
        userStepPermissions.add('accept/reject');
      }
      break;
    case 'projectManager':
      userStepPermissions.add('view_task');
      userStepPermissions.add('view_completion_step');
      userStepPermissions.add('add_comment');
      break;
    case 'notify':
      userStepPermissions.add('view_task');
      userStepPermissions.add('view_completion_step');
      userStepPermissions.add('add_comment');
      break;
    default:
      if (userRole == 'editor') {
        userStepPermissions.add('view_task');
        userStepPermissions.add('view_completion_step');
        userStepPermissions.add('add_comment');
        userStepPermissions.add('can_mark_all');
      }
      break;
    }
    break;
  case 'pending_approval':
    switch (assignments.userAssignment) {
    case 'assignedTo':
      userStepPermissions.add('view_task');
      userStepPermissions.add('view_completion_step');
      userStepPermissions.add('photo_upload');
      userStepPermissions.add('photo_delete');
      userStepPermissions.add('add_comment');
      if (!task.has_reviewer) {
        userStepPermissions.add('step_complete');
            // ****TODO this is how it should be according to the trello card, but Dave said not to mess with it yet.
            // userStepPermissions.add('photo_upload')
            // userStepPermissions.add('photo_delete')
      }
      if (completionStep) {
        if (completionStep.status == 'completed') {
          if (task.has_reviewer && !completionStep.reviewed_at) {
            userStepPermissions.add('unmarkNA');
          }
          else if (!task.has_reviewer && task.has_approver && !completionStep.approved_at) {
            userStepPermissions.add('unmarkNA');
          }
        }
      }
      break;
    case 'reviewer':
      userStepPermissions.add('view_task');
      userStepPermissions.add('view_completion_step');
      userStepPermissions.add('add_comment');
      break;
    case 'approver':
      userStepPermissions.add('view_task');
      userStepPermissions.add('view_completion_step');
      userStepPermissions.add('add_comment');
      if (completionStep && completionStep.completed_at && task.has_approver && !completionStep.approved_at && !completionStep.rejected_at && ((task.has_reviewer && completionStep.reviewed_at) || !task.has_reviewer)) {
        userStepPermissions.add('accept/reject');
      }
      userStepPermissions.add('mark_as_reviewed');
      break;
    case 'projectManager':
      userStepPermissions.add('view_task');
      userStepPermissions.add('view_completion_step');
      userStepPermissions.add('add_comment');
      break;
    case 'notify':
      userStepPermissions.add('view_task');
      userStepPermissions.add('view_completion_step');
      userStepPermissions.add('add_comment');

      break;
    default:
      if (userRole == 'editor') {
        userStepPermissions.add('view_task');
        userStepPermissions.add('view_completion_step');
        userStepPermissions.add('add_comment');
        userStepPermissions.add('can_mark_all');
      }
      break;
    }
    break;
  case 'complete':
  case 'completed':
    switch (assignments.userAssignment) {
    case 'assignedTo':
      userStepPermissions.add('view_task');
      userStepPermissions.add('view_completion_step');
      userStepPermissions.add('photo_upload');
      userStepPermissions.add('photo_delete');
      userStepPermissions.add('add_comment');
      if (!task.has_reviewer && !task.has_approver) {
        userStepPermissions.add('unmarkNA');
      }
      break;
    case 'reviewer':
      userStepPermissions.add('view_task');
      userStepPermissions.add('view_completion_step');
      userStepPermissions.add('add_comment');
      if (!task.has_reviewer && !task.has_approver) {
        userStepPermissions.add('unmarkNA');
      }
      break;
    case 'approver':
      userStepPermissions.add('view_task');
      userStepPermissions.add('view_completion_step');
      userStepPermissions.add('add_comment');
      break;
    case 'projectManager':
      userStepPermissions.add('view_task');
      userStepPermissions.add('view_completion_step');
      userStepPermissions.add('add_comment');
      if (!task.has_reviewer && !task.has_approver) {
        userStepPermissions.add('unmarkNA');
      }
      break;
    case 'notify':
      userStepPermissions.add('view_task');
      userStepPermissions.add('view_completion_step');
      userStepPermissions.add('add_comment');
      break;
    default:
      if (userRole == 'editor') {
        userStepPermissions.add('view_task');
        userStepPermissions.add('view_completion_step');
        userStepPermissions.add('add_comment');
        if (!task.has_reviewer && !task.has_approver) {
          userStepPermissions.add('unmarkNA');
        }
      }
      break;
    }
    break;
  default:
    break;
  }

  return userStepPermissions;
}

// Helper function for getCompletionStepUserPermissions() (below)
function projectPermissions({ view, task, taskStatus, userRole, assignments, isVendor, completionStep }) {
  const userStepPermissions = new Set();

  if (userRole == 'super_user') {
    userStepPermissions.add('photo_upload');
    userStepPermissions.add('photo_delete');
    userStepPermissions.add('step_complete');
    if (completionStep && completionStep.completed_at && !completionStep.rejected_at && ((task.has_approver && !completionStep.approved_at) || (task.has_reviewer && !completionStep.reviewed_at))) {
      if (task.has_reviewer && !completionStep.reviewed_at) {
        userStepPermissions.add('is_reviewer');
      }
      else if (task.has_approver && !completionStep.approved_at) {
        userStepPermissions.add('is_approver');
      }
      userStepPermissions.add('accept/reject');
    }
    switch (taskStatus) {
    case 'not_started':
      userStepPermissions.add('step_complete');
      userStepPermissions.add('mark_as_complete');
      userStepPermissions.add('photo_upload');
      userStepPermissions.add('photo_delete');
      userStepPermissions.add('add_comment');
      break;
    case 'in_progress':
      userStepPermissions.add('step_complete');
      userStepPermissions.add('mark_as_complete');
      userStepPermissions.add('override');
      userStepPermissions.add('photo_upload');
      userStepPermissions.add('photo_delete');
      userStepPermissions.add('add_comment');
      break;
    case 'rejected':
      userStepPermissions.add('step_complete');
      userStepPermissions.add('override');
      userStepPermissions.add('mark_as_complete');
      userStepPermissions.add('photo_upload');
      userStepPermissions.add('photo_delete');
      userStepPermissions.add('add_comment');
      break;
    case 'pending_review':
      userStepPermissions.add('mark_as_reviewed');
      userStepPermissions.add('override');
      userStepPermissions.add('photo_upload');
      userStepPermissions.add('photo_delete');
      userStepPermissions.add('add_comment');
      break;
    case 'pending_approval':
      userStepPermissions.add('override');
      userStepPermissions.add('mark_as_approved');
      userStepPermissions.add('photo_upload');
      userStepPermissions.add('photo_delete');
      userStepPermissions.add('add_comment');
      break;
    case 'completed':
    case 'complete':
      userStepPermissions.add('view_task');
      userStepPermissions.add('view_completion_step');
      userStepPermissions.add('photo_upload');
      userStepPermissions.add('photo_delete');
      userStepPermissions.add('add_comment');
      break;
    default:
      break;
    }
  }
  else if (userRole == 'editor' || userRole == 'admin') {
    if (isVendor) {
      // treat like build owner...
      permissionsForAssignment({ task, taskStatus, assignments, completionStep }).forEach(userStepPermissions.add, userStepPermissions);
    } else {

      userStepPermissions.add(assignments.userAssignment);

      userStepPermissions.add('photo_upload');
      userStepPermissions.add('photo_delete');
      userStepPermissions.add('step_complete');
      userStepPermissions.add('can_mark_all');
      if (completionStep && completionStep.completed_at && !completionStep.rejected_at && ((task.has_approver && !completionStep.approved_at) || (task.has_reviewer && !completionStep.reviewed_at))){
        if (task.has_reviewer && !completionStep.reviewed_at) {
          userStepPermissions.add('is_reviewer');
        }
        else if (task.has_approver && !completionStep.approved_at) {
          userStepPermissions.add('is_approver');
        }
        userStepPermissions.add('accept/reject');
      }
      switch (taskStatus) {
      case 'not_started':
        userStepPermissions.add('mark_as_complete');
        break;
      case 'in_progress':
        userStepPermissions.add('override');
        if (assignments.userAssignment == 'assignedTo') {
          userStepPermissions.add('mark_as_complete');
        }
        userStepPermissions.add('mark_as_complete');
        break;
      case 'rejected':
        userStepPermissions.add('override');
        userStepPermissions.add('mark_as_complete');

        break;
      case 'pending_review':
        userStepPermissions.add('override');
        userStepPermissions.add('mark_as_reviewed');
        break;
      case 'pending_approval':
        userStepPermissions.add('mark_as_approved');
        break;
      case 'completed':
      case 'complete':
        break;
      default:
        break;
      }
    }
  }
  else if (assignments.buildOwnerAssignment == 'build_owner' || userRole == 'build_owner') {
    permissionsForAssignment({ task, taskStatus, assignments, completionStep }).forEach(userStepPermissions.add, userStepPermissions);
  }
  return userStepPermissions;
}

// TODO: this needs cleanup, particularly with assignments
function permissionsForAssignment({ task, taskStatus, assignments, completionStep }) {
  const userStepPermissions = new Set();
  const { buildOwnerAssignment, userAssignment } = assignments;
  if (task && completionStep) {
    if (task.has_reviewer && !completionStep.reviewed_at) {
      userStepPermissions.add('is_reviewer');
    }
    else if (task.has_approver && !completionStep.approved_at) {
      userStepPermissions.add('is_approver');
    }
  }
  if (buildOwnerAssignment == 'build_owner') {
    userStepPermissions.add('photo_upload');
    userStepPermissions.add('photo_delete');
    userStepPermissions.add('step_complete');
    switch (taskStatus) {
    case 'not_started':
      if (userAssignment == 'approver' || userAssignment == 'reviewer') {
        userStepPermissions.add('mark_as_complete');  
      }
      break;
    case 'in_progress':
      userStepPermissions.add('override');
      userStepPermissions.add('add_comment');
      if (userAssignment == 'approver' || userAssignment == 'reviewer') {
        userStepPermissions.add('mark_as_complete');  
      }
      break;
    case 'rejected':
      userStepPermissions.add('override');
      userStepPermissions.add('add_comment');
      break;
    case 'pending_review':
      userStepPermissions.add('override');
      userStepPermissions.add('add_comment');
      if (userAssignment == 'reviewer') {
        userStepPermissions.add('mark_as_reviewed');
      }
      break;
    case 'pending_approval':
      userStepPermissions.add('override');
      if (userAssignment == 'approver') {
        userStepPermissions.add('mark_as_approved');
      }
      userStepPermissions.add('add_comment');
      break;
    case 'completed':
    case 'complete':
      userStepPermissions.add('view_task');
      userStepPermissions.add('view_completion_step');
      userStepPermissions.add('add_comment');
      break;
    default:
      break;
    }
  }
  if (assignments.userAssignment == 'assignedTo') {
    userStepPermissions.add('photo_upload');
    userStepPermissions.add('photo_delete');
    switch (taskStatus) {
    case 'not_started':
      userStepPermissions.add('step_complete');
      break;
    case 'in_progress':
      userStepPermissions.add('step_complete');
      userStepPermissions.add('override');
      break;
    case 'rejected':
      userStepPermissions.add('step_complete');
      userStepPermissions.add('override');
      userStepPermissions.add('accept/reject');
      break;
    case 'pending_review':
      userStepPermissions.add('override');
      break;
    default:
      break;
    }
  }
  else if (assignments.userAssignment == 'reviewer') {
    switch (taskStatus) {
    case 'in_progress':
      if (completionStep && completionStep.completed_at && task.has_reviewer && !completionStep.reviewed_at && !completionStep.rejected_at) {
        userStepPermissions.add('accept/reject');
      }
      else if (completionStep && completionStep.completed_at && task.has_approver && !completionStep.approved_at && !completionStep.rejected_at && ((task.has_reviewer && completionStep.reviewed_at) || !task.has_reviewer)) {
        userStepPermissions.add('accept/reject');
      }
      break;
    case 'rejected':
      userStepPermissions.add('accept/reject');
      break;
    case 'pending_review':
      if (completionStep && completionStep.completed_at && task.has_reviewer && !completionStep.reviewed_at && !completionStep.rejected_at) {
        userStepPermissions.add('accept/reject');
      }
      break;
    default:
      break;
    }
  }
  else if (assignments.userAssignment == 'approver') {
    switch (taskStatus) {
    case 'pending_approval':
      if (completionStep && completionStep.completed_at && task.has_approver && !completionStep.approved_at && !completionStep.rejected_at && ((task.has_reviewer && completionStep.reviewed_at) || !task.has_reviewer)) {
        userStepPermissions.add('accept/reject');
      }
      break;
    default:
      break;
    }
  }
  return userStepPermissions;
}

function checkIfRejected(task){
  const stepsRejected = task.completion_criteria
  ? task.completion_criteria.filter(cc => {
    if (cc) {
      return (
        cc.rejected_at &&
        !cc.approved_at &&
        !cc.reviewed_at &&
        !cc.completed_at
      );
    }
    else {
      return false;
    }
  }
  )
  : [];
  if(stepsRejected.length > 0) return 'rejected';
  else return 'in_progress';
}

export function getCompletionStepUserPermissions({
  currentCompany,
  currentUser,
  isBuildOwner,
  project,
  task,
  view,
  completionStep,
  isVendor }) {
  
  if (view == 'projectTemplates' || !task){
    return new Set();
  }
  
  if (!currentUser) {
    return new Set();
  }

  //calculate taskStatus
  let taskStatus = task.status;
  if(taskStatus == 'in_progress' && task){
    taskStatus = checkIfRejected(task);
  }

  //get user role
  const currentRole = currentUser ? currentUser.role : null;
  let currentUserRoleName = currentRole ? currentRole.name : null;
  let userRole = currentUserRoleName;

  //get assigned users for task
  let fieldUsers = [];
  let reviewerUsers = [];
  let approverUsers = [];
  let notifyUsers = [];

  if (task) {
    fieldUsers = getUserTaskAssignments(task, 'field_user');
    reviewerUsers = getUserTaskAssignments(task, 'reviewer');
    approverUsers = getUserTaskAssignments(task, 'approver');
    notifyUsers = getUserTaskAssignments(task, 'notify');
  }

  //determines user assignment
  let assignments = determineUserAssignment(currentCompany, currentUser, isBuildOwner, project, view, fieldUsers, reviewerUsers, approverUsers, notifyUsers);

  return createAssignmentPermissions(view, task, taskStatus, userRole, assignments, isVendor, completionStep);
}

function determineIfBuildOwner(view, isBuildOwner, currentUser, currentCompany) {
  if (view == 'projects' && isBuildOwner && currentUser.companies) {
    
    // Check if build owner comes from vendor company - only apply build owner permissions in this case
    // If there's a better way to check this, feel free to refactor
    for (let currentUserCompany of currentUser.companies) {
      if (currentUserCompany.parent_companies) {
        for (let parentCompany of currentUserCompany.parent_companies) {
          if (parentCompany.id == currentCompany.id) {
            return true;
          }
        }
      }
    }
  }
}

function getUserTaskAssignments(task, assignmentType) {
  if (task && task.user_task_assignments) {
    return task.user_task_assignments.filter(user_task_assignment => {
      if (user_task_assignment && user_task_assignment.assignment_type == assignmentType) {
        if (user_task_assignment.user) {
          user_task_assignment.user_id = user_task_assignment.user.id;
        }
        return true;
      } else {
        return false;
      }
    });
  }
}

function determineUserAssignment(currentCompany, currentUser, isBuildOwner, project, view, fieldUsers, reviewerUsers, approverUsers, notifyUsers) {
  let userAssignment = null;

  //Determine user assignment
  const buildOwnerAssignment = determineIfBuildOwner(view, isBuildOwner, currentUser, currentCompany) ? 'build_owner' : null;

  // This is the project manager ASSIGNMENT which is separate from the PM user role
  if(project && project.project_manager && project.project_manager.id == currentUser.id){
    userAssignment = 'projectManager';
  }

  // Check if current user is in assignment - other assignments take priority over PM
  const isFieldUser = fieldUsers && fieldUsers.length ? fieldUsers.find(val => val.user_id == currentUser.id)  : false;
  userAssignment = isFieldUser ? 'assignedTo' : userAssignment;

  if (reviewerUsers) {
    reviewerUsers.forEach(reviewer_user => {
      if (reviewer_user.user_id == currentUser.id) {
        userAssignment = 'reviewer';
      }
    });
  }
  if (approverUsers) {
    approverUsers.forEach(approver_user => {
      if (approver_user.user_id == currentUser.id) {
        userAssignment = 'approver';
      }
    });
  }
  if (!userAssignment && notifyUsers) {
    notifyUsers.forEach(notify_user => {
      if (notify_user.user_id == currentUser.id) {
        userAssignment = 'notify';
      }
    });
  }
  return { buildOwnerAssignment, userAssignment };
}

function createAssignmentPermissions(view, task, taskStatus, userRole, assignments, isVendor, completionStep) {
    /**
 * @param  {string} taskStatus - Can be 'not_started', 'in_progress', 'rejected', 'pending_review', 'pending_approval', 'completed'
 * @param  {string} userRole - Should be from currentUser.role.name. (or build owner) Can be 'super_user', 'admin', 'project_manager', 'primary_contact', 'standard_user', 'view_only', 'build_owner'
 * @param  {string} userAssignment - Can be 'assignedTo', 'reviewer', 'approver', 'unassigned', or 'projectManager'
 * @param  {string} view - Can be 'projects' or 'tasks'
 * 
 * @returns {Set<string>} - Set of permissions the user has based on the supplied params. Possible members are 'mark_as_approved', 'mark_as_complete', 'mark_as_reviewed', 'step_complete' 'override', 'photo_upload', and 'accept/reject'
 */
  if (view == 'tasks') {
    return tasksPermissions({ view, task, taskStatus, userRole, assignments, isVendor });
  }
  else if (view == 'projects') {
    return projectPermissions({ view, task, taskStatus, userRole, assignments, isVendor, completionStep });
  }
  else if (view == 'completionStep') {
    return tasksPermissions({ view, task, taskStatus, userRole, assignments, isVendor, completionStep });
  }
  else return new Set();
}

export default {
  getCompletionStepUserPermissions,
  canOverrideUpload,
  canCompleteStep,
};



// WEBPACK FOOTER //
// ./src/helpers/permissions/CompletionStepPermissionsUtil.js